/* ----------------------------------------
    AI Assistant Panel
---------------------------------------- */

export class AIAssistantPanel {
    constructor() {
        this._panel = document.querySelector('#js-ai-assistant-panel');
        this._openButton = document.querySelector('#js-open-ai-assistant');
        this._closeButton = document.querySelector('#js-ai-assistant-close');
        this._resizeButton = document.querySelector('#js-ai-assistant-resize');

        if (!this._panel) return;

        this._overlay = this._panel.querySelector('.ai-assistant-panel__overlay');

        this._init();
    }

    /* ----------------------------------------
        Open Panel
    ---------------------------------------- */

    _openPanel() {
        if (!this._panel) return;

        this._panel.classList.add('is-open');
        document.body.classList.add('is-locked');
        document.body.style.overflow = 'hidden';
    }

    /* ----------------------------------------
        Close Panel
    ---------------------------------------- */

    _closePanel() {
        if (!this._panel) return;

        this._panel.classList.remove('is-open');
        this._panel.classList.remove('is-expanded');
        document.body.classList.remove('is-locked');
        document.body.style.overflow = '';
    }

    /* ----------------------------------------
        Toggle Resize
    ---------------------------------------- */

    _toggleResize() {
        if (!this._panel) return;

        const isExpanded = this._panel.classList.toggle('is-expanded');

        if (this._resizeButton) {
            this._resizeButton.setAttribute('aria-label',
                isExpanded ? 'Collapse AI Assistant' : 'Expand AI Assistant'
            );
        }
    }

    /* ----------------------------------------
        Initialize
    ---------------------------------------- */

    _init() {
        if (this._openButton) {
            setTimeout(() => {
                this._openButton.classList.add('is-visible');
            }, 2000);
            this._openButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this._openPanel();
            });
        }

        if (this._closeButton) {
            this._closeButton.addEventListener('click', () => {
                this._closePanel();
            });
        }

        if (this._resizeButton) {
            this._resizeButton.addEventListener('click', () => {
                this._toggleResize();
            });
        }

        if (this._overlay) {
            this._overlay.addEventListener('click', () => {
                this._closePanel();
            });
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this._panel && this._panel.classList.contains('is-open')) {
                this._closePanel();
            }
        });
    }
}
